import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import artworksData from '../../data/artworks.json'
import GalleryFilters from './GalleryFilters'
import GalleryGrid from './GalleryGrid'
import ArtworkLightbox from './Lightbox'

export default function Gallery() {
  const { artworkId } = useParams()
  const navigate = useNavigate()

  const [selectedCategory, setSelectedCategory] = useState('all')
  const [selectedArtwork, setSelectedArtwork] = useState(null)
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)
  const scrollPositionRef = useRef(0)

  // Filter artworks by category
  const filteredArtworks = artworksData.artworks.filter(artwork => {
    if (selectedCategory === 'all') return true
    return artwork.category === selectedCategory
  }).sort((a, b) => a.displayOrder - b.displayOrder)

  // Handle deep linking to specific artwork
  useEffect(() => {
    if (artworkId) {
      const artwork = artworksData.artworks.find(a => a.id === artworkId)
      if (artwork) {
        setSelectedArtwork(artwork)
        setIsLightboxOpen(true)
      }
    }
  }, [artworkId])

  const handleArtworkClick = (artwork) => {
    scrollPositionRef.current = window.scrollY
    setSelectedArtwork(artwork)
    setIsLightboxOpen(true)
    // Update URL for deep linking
    navigate(`/werke/${artwork.id}`, { replace: true })
  }

  const handleCloseLightbox = () => {
    setIsLightboxOpen(false)
    setSelectedArtwork(null)
    // Return to gallery view
    navigate('/werke', { replace: true })
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPositionRef.current)
    })
  }

  const handleNavigate = (artwork) => {
    setSelectedArtwork(artwork)
    navigate(`/werke/${artwork.id}`, { replace: true })
  }

  return (
    <div>
      {/* Category Filters */}
      <GalleryFilters
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />

      {/* Gallery Grid */}
      <GalleryGrid
        artworks={filteredArtworks}
        onArtworkClick={handleArtworkClick}
      />

      {/* Lightbox */}
      <ArtworkLightbox
        artwork={selectedArtwork}
        isOpen={isLightboxOpen}
        onClose={handleCloseLightbox}
        allArtworks={filteredArtworks}
        onNavigate={handleNavigate}
      />
    </div>
  )
}
